var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 3a3 3 0 0 0-2.998 3.06A17 17 0 0 0 18 22a3 3 0 0 0 3-3v-4a1 1 0 0 0-.629-.928l-5-2a1 1 0 0 0-1.229.414l-1.004 1.673a10 10 0 0 1-3.297-3.297l1.674-1.005a1 1 0 0 0 .413-1.228l-2-5A1 1 0 0 0 9 3zm-.707 2.293A1 1 0 0 1 5 5h3.323l1.432 3.58-1.77 1.063a1 1 0 0 0-.382 1.3 12 12 0 0 0 5.455 5.454 1 1 0 0 0 1.3-.382l1.061-1.77L19 15.677V19a1 1 0 0 1-.974 1A15 15 0 0 1 4 5.974a1 1 0 0 1 .293-.681",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;